import React from 'react';
import NavBar from '../NavBar';
import { Footer } from '../Footer/Footer';
import './TermsAndCondition.css';

export const TermsAndCondition = () => {
  return (
    <>
      <NavBar currentPath="termsandcondition" />
      <div className="terms-and-condition-container">
        <div className="TermsAndConditions">
          <h1 className="termsH1">Terms and Conditions</h1>
          <p>Effective Date: July 6th, 2025</p>
          <p>
            These Terms and Conditions ("Agreement") govern your use of CashClever ("the Platform,"
            "we," "us," or "our") and the services provided on our website or mobile application
            ("the Site"). By accessing or using the Platform, you ("User," "you," or "your") agree
            to abide by and be bound by this Agreement. If you do not agree to these terms, you
            should not use the Platform.
          </p>
          <ol className="termsOl">
            <h3>Introduction</h3>
            <li className="termsLi">
              1.1 <i className="companyName"> CashClever</i> provides an online platform that
              connects users with third-party lenders offering auto and mortgage loans.
            </li>
            <li className="termsLi">
              1.2 The Platform does not lend money directly and is not a party to any loan agreement
              between you and a lender.
            </li>
            <h3>User Eligibility</h3>
            <li className="termsLi">
              2.1 To use the Platform, you must be at least 18 years old (or the age of majority in
              your jurisdiction) and have the legal capacity to enter into binding contracts.
            </li>
            <li className="termsLi">
              2.2 You must provide accurate and complete information during registration, including
              but not limited to your name, email address, phone number, financial details, and any
              other information necessary to process your loan application.
            </li>
            <li className="termsLi">
              2.3 You agree to update your information as necessary to keep it accurate and
              complete.
            </li>

            <h3>Account Registration and Security</h3>
            <li className="termsLi">
              3.1 To access certain services, you must create an account on the Platform. You are
              responsible for maintaining the confidentiality of your login credentials and for all
              activities that occur under your account.
            </li>
            <li className="termsLi">
              3.2 If you believe that your account has been compromised or that there has been
              unauthorized access, you must notify us immediately.
            </li>

            <h3>Loan Application Process</h3>
            <li className="termsLi">
              4.1 When you apply for a loan, you will submit personal, financial, and loan-related
              information to the Platform. The Platform will use this information to connect you
              with multiple lenders who may provide you with loan offers.
            </li>
            <li className="termsLi">
              4.2 By submitting your loan application, you authorize the Platform and its
              third-party lenders to verify the information you provide and to conduct credit
              checks.
            </li>
            <li className="termsLi">
              4.3 Soft Credit Check: We will perform a soft credit check as part of the application
              process. A soft credit check is a non-invasive check that will not impact your credit
              score in any way. This is used solely to assess your eligibility for loan offers and
              to match you with appropriate lenders.
            </li>
            <li className="termsLi">
              4.4 You acknowledge that loan offers from lenders are subject to their approval
              processes and that the Platform does not guarantee loan approval, funding, or any
              specific loan terms.
            </li>
            <h3>Use of the Platform</h3>
            <li className="termsLi">
              5.1 You agree to use the Platform solely for lawful purposes and in accordance with
              these Terms and Conditions.
            </li>
            <li className="termsLi">
              5.2 You may not use the Platform to engage in any fraudulent activity, provide false
              information, or interfere with the operation of the Platform.
            </li>
            <li className="termsLi">
              5.3 You may not use the Platform to solicit or promote competing services or products.
            </li>
            <h3>Privacy and Data Collection</h3>
            <li className="termsLi">
              6.1 By using the Platform, you agree to our collection, use, and sharing of your
              personal and financial information as outlined in our Privacy Policy.
            </li>
            <li className="termsLi">
              6.2 You consent to the Platform sharing your information with third-party lenders for
              the purpose of facilitating loan offers and processing your application.
            </li>
            <li className="termsLi">
              6.3 We use industry-standard security measures to protect your information, but we
              cannot guarantee the absolute security of your data.
            </li>
            <h3>Fees and Charges</h3>
            <li className="termsLi">
              7.1 Using the Platform to compare loan offers is free. However, individual lenders may
              charge fees such as origination fees, prepayment penalties, or other costs, which will
              be disclosed to you by the lender prior to accepting any loan offer.
            </li>
            <li className="termsLi">
              7.2 You are responsible for reviewing all terms and conditions associated with any
              loan offer, including fees and charges, before proceeding with the loan.
            </li>
            <h3>Disclaimers and Limitation of Liability</h3>
            <li className="termsLi">
              8.1 The Platform acts as an intermediary to connect you with third-party lenders and
              does not endorse or guarantee any lender or loan offer. All loan agreements are
              between you and the lender.
            </li>
            <li className="termsLi">
              8.2 We do not guarantee that you will receive a loan offer, or that any loan offer
              will meet your expectations or financial needs.
            </li>
            <li className="termsLi">
              8.3 The Platform is provided "as is" and we disclaim all warranties, express or
              implied, including any implied warranties of merchantability or fitness for a
              particular purpose.
            </li>
            <li className="termsLi">
              8.4 To the fullest extent permitted by law, we are not liable for any damages,
              including indirect, incidental, or consequential damages, arising from your use of the
              Platform or any loan transaction.
            </li>
            <h3>Dispute Resolution and Governing Law</h3>
            <li className="termsLi">
              9.1 Any disputes arising from or relating to this Agreement or the use of the Platform
              will be resolved through binding arbitration, rather than in court.
            </li>
            <li className="termsLi">
              9.2 The arbitration will be conducted in accordance with the rules of the American
              Arbitration Association (AAA) and shall take place in Delaware, USA.
            </li>
            <li className="termsLi">
              9.3 This Agreement is governed by and construed in accordance with the laws of the
              State of Delaware, USA, without regard to its conflict of law principles.
            </li>
            <h3>Modifications to Terms and Conditions</h3>
            <li className="termsLi">
              10.1 We reserve the right to modify, update, or change these Terms and Conditions at
              any time. Any changes will be effective immediately upon posting on the Site.
            </li>
            <li className="termsLi">
              10.2 It is your responsibility to review these Terms and Conditions regularly for any
              updates. Your continued use of the Platform after any changes signifies your
              acceptance of the modified terms.
            </li>
            <h3>Termination of Access</h3>
            <li className="termsLi">
              11.1 We may suspend or terminate your access to the Platform at any time, without
              notice, for any reason, including but not limited to violations of these Terms and
              Conditions.
            </li>
            <li className="termsLi">
              11.2 You may terminate your account by contacting us directly. Termination will not
              affect any obligations or liabilities incurred prior to the termination.
            </li>
            <h3>Contact Information</h3>
            <li className="termsLi">
              If you have any questions about these Terms and Conditions, or if you need to contact
              us for any reason, please reach out to us at:
            </li>
            <li className="termsLi">
              <br></br>
              CashClever Corp.<br></br> 2 University Plaza, Suite 100 <br></br> Hackensack, NJ.
              07601
              <br></br> Info@CashClever.net <br></br>
              646 - 780 - 9673
            </li>
            <h3>Acknowledgment</h3>
            <li className="termsLi">
              By clicking "Sign Up", providing your email for rates, or by accessing and using the
              Platform, you acknowledge that you have read, understood, and agree to these Terms and
              Conditions.
            </li>
          </ol>
        </div>
      </div>

      <Footer currentPath={'/terms_and_conditions'} />
    </>
  );
};
